import { createScopedCache } from '@/lib/storage/scopedCache';
import type { EvaluationInsightsResponse } from '@/modules/simulations/types';

export const insightsCache = createScopedCache<EvaluationInsightsResponse, number>({
  namespace: 'sim_insights',
  schemaVersion: 'v1',
  ttlMs: 30 * 24 * 60 * 60 * 1000, // 30 days
  maxEntries: 50,
});
